import script from "./BasicCard.vue?vue&type=script&setup=true&lang=js"
export * from "./BasicCard.vue?vue&type=script&setup=true&lang=js"

import "./BasicCard.vue?vue&type=style&index=0&id=17fd3d0b&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17fd3d0b"]])

export default __exports__